import { Link } from "react-router-dom";
import { Reveal } from "@/components/Motion";
import { Truck, Clock, Camera, PhoneCall, ArrowLeft } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function Policy() {
  return (
    <div className="max-w-[900px] mx-auto px-5 md:px-10 pt-36 pb-28 min-h-screen">
      <Reveal>
        <span className="mono-label text-cyan">Shipping & DOA</span>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight mt-4 mb-8">Livestock shipping & guarantee</h1>
      </Reveal>

      <Reveal delay={0.05}>
        <div className="glass rounded-2xl p-8 border border-white/10 mb-6">
          <Truck className="text-cyan mb-4" size={26} />
          <h2 className="font-display text-2xl mb-3">Shipping rates</h2>
          <ul className="text-white/60 space-y-2 leading-relaxed">
            <li>• <b className="text-white">$50 flat shipping rate</b> on all livestock (corals & fish).</li>
            <li>• <b className="text-cyan">FREE shipping</b> on any order <b className="text-white">over $450</b>.</li>
            <li>• <b className="text-white">Livestock ships Tuesdays & Wednesdays only</b> — for the safety of the animals, we ship early in the week so nothing sits in a facility over the weekend.</li>
            <li>• Livestock ships only when weather and transit conditions are safe for the animals.</li>
          </ul>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="glass rounded-2xl p-8 border border-toxic/25">
          <Clock className="text-toxic mb-4" size={26} />
          <h2 className="font-display text-2xl mb-3">DOA (Dead On Arrival) claim policy</h2>
          <p className="text-white/60 leading-relaxed mb-5">
            We want every fish and coral to arrive healthy. If something arrives DOA, you're covered — but claims are strictly time-sensitive:
          </p>
          <div className="grid sm:grid-cols-3 gap-4 mb-6">
            <div className="rounded-xl bg-white/[0.03] border border-white/10 p-5">
              <Clock className="text-toxic mb-2" size={20} />
              <p className="text-white/80 text-sm"><b className="text-white">3 hours</b> from delivery to submit your claim.</p>
            </div>
            <div className="rounded-xl bg-white/[0.03] border border-white/10 p-5">
              <PhoneCall className="text-cyan mb-2" size={20} />
              <p className="text-white/80 text-sm">Call/text <a href={BRAND.phoneHref} className="text-cyan">{BRAND.phone}</a> to report it.</p>
            </div>
            <div className="rounded-xl bg-white/[0.03] border border-white/10 p-5">
              <Camera className="text-cyan mb-2" size={20} />
              <p className="text-white/80 text-sm">Send clear photos of the <b className="text-white">fish/coral</b> and the <b className="text-white">box condition</b>.</p>
            </div>
          </div>
          <p className="text-white/45 text-sm leading-relaxed">
            Claims submitted after the 3-hour window, or without photos of both the specimen and the shipping box, cannot be honored. Please open your package promptly on arrival and inspect all livestock right away.
          </p>
        </div>
      </Reveal>

      <Link to="/shop" className="btn-pill inline-flex items-center gap-2 mt-10"><ArrowLeft size={15} /> Back to shop</Link>
    </div>
  );
}
